module.exports = __webpack_public_path__ + "img/pro-d3.c11c26f4.jpg";